<template>
  <div class="app-layout">
    <router-view v-if="isH5"></router-view>
    <div class="mobile" v-else>
      <div>
        <img src="@/assets/img/login-box-bg.svg" alt="">
        <h3>星域平台管理系统</h3>
        <p>当前访问地址为移动端，请采用下列方式登录PC（电脑端）站点</p>
        <p><a href="http://www.chensc.com.cn">http://www.chensc.com.cn</a></p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
// 获取用户代理字符串
const userAgent = navigator.userAgent;
let isH5 = ref(true)
// 判断是否为手机设备
if (!(/(Android|iPhone|iPad|iPod|Mobile)/.test(userAgent))) {
  isH5.value = false
}
</script>

<style lang="less">
.app-layout {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  background-color: #f7f8fa;

  .mobile {
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    overflow: hidden;
    line-height: 30px;

    img {
      height: 50%;
      width: 50%;
    }

    a {
      color: #1989fa;
    }
  }
}
</style>
